export const ANIMATIONS_STYLES = {
    'animation_cards_add-card-ios': 'animation_cards_add-card-ios.json',
    'animation_cards_add-cards-android': 'animation_cards_add-cards-android.json',
    'animation_cards_add-cards-samsung': 'animation_cards_add-cards-samsung.json',
    'animation_cards_pay-shortcut-android': 'animation_cards_pay-shortcut-android.json',
    'animation_cards_pay-shortcut-ios': 'animation_cards_pay-shortcut-ios.json',
    'animation_cards_pay-shortcut-samsung': 'animation_cards_pay-shortcut-samsung.json',
    'animation_cards_watch-ios': 'animation_cards_watch-ios.json',
    /**
     * @deprecated
     * Use BUBBLE instead
     */
    'animation_loader_bubble': 'animation_loader_bubble.json',
    'BUBBLE': 'animation_loader_bubble.json',
    /**
     * @deprecated
     * Use CHAT instead
     */
    'animation_loader_chat': 'animation_loader_chat.json',
    'CHAT': 'animation_loader_chat.json',
    /**
     * @deprecated
     * Use PRIMARY instead
     */
    'animation_loader_primary': 'animation_loader_primary.json',
    'PRIMARY': 'animation_loader_primary.json',
    /**
     * @deprecated
     * Use SECONDARY instead
     */
    'animation_loader_secondary': 'animation_loader_secondary.json',
    'SECONDARY': 'animation_loader_secondary.json',
    /**
     * @deprecated
     * Use SECONDARY_INPUTS instead
     */
    'animation_loader_secondary_inputs': 'animation_loader_secondary_inputs.json',
    'SECONDARY_INPUTS': 'animation_loader_secondary_inputs.json',
    /**
     * @deprecated
     * Use TERTIARY instead
     */
    'animation_loader-tertiary': 'animation_loader-tertiary.json',
    'TERTIARY': 'animation_loader-tertiary.json',
    /**
     * @deprecated
     * Use TERTIARY_ON_SURFACE instead
     */
    'animation_loader-tertiary-onsurface': 'animation_loader-tertiary-onsurface.json',
    'TERTIARY_ON_SURFACE': 'animation_loader-tertiary-onsurface.json',
    /**
     * @deprecated
     * Use TERTIARY_TECH_ONLY instead
     */
    'animation_loader-tertiary-techonly': 'animation_loader-tertiary-techonly.json',
    'TERTIARY_TECH_ONLY': 'animation_loader-tertiary-techonly.json',
    /**
     * @deprecated
     * Use another CONTACT_CENTER animation instead
     */
    'animation_loader-contactcenter': 'animation_loader-contactcenter.json',
    'CONTACT_CENTER_PRIMARY': 'animation_loader_contact-center_primary',
    'CONTACT_CENTER_SECONDARY': 'animation_loader_contact-center_secondary',
    'CONTACT_CENTER_INPUTS': 'animation_loader_contact-center_inputs.json',
};
export const RELOADED_ANIMATIONS = (() => {
    const result = {};
    Object.keys(ANIMATIONS_STYLES).forEach(animation => {
        result[animation] = animation;
    });
    return result;
})();
//# sourceMappingURL=animations.js.map